
import { Component, Vue, Ref } from 'vue-property-decorator'
import { ClueService } from '@/services'
import { withApiHost } from '@/common/utils'
import Publish from './components/publish.vue'
import mediumZoom from 'medium-zoom'
import ReportedDialog from './components/reportedDialog.vue'
import NotpassDialog from './components/notpassDailog.vue'

@Component({
    components: {
        Publish,
        ReportedDialog,
        NotpassDialog
    }
})
export default class ClueDetail extends Vue {
    private isLoading = true
    private loadingText = ''
    private imgLimit = 9
    private clueId = 0
    private clueSortList = []
    private typeSelect = ''
    private elseInfo = {
        user: {},
        clue_source: '',
        channel: ''
    }
    private clueData: any = { 
        clue_type_id: '',
        title: '',
        content: '',
        images: [],
        annexes: []
    }
    private status = {
        ing: 0,
        pass: 1,
        fail: 2
    }
    private notPassReason = ''
    private isReport = false
    private mediumZoomEl!: NodeListOf<Element>
    private notPassReasons: any[] = []
    private reasonId: any = ''

    @Ref('publishRef') private publishRef: any
    @Ref('reportDialog') private reportDialog: any
    @Ref('notpassDialog') private notpassDialog: any

    private created() {
        this.clueId = +this.$route.params.id
        if (this.$route.query.report) this.isReport = true
    }

    private async mounted() {
        this.isLoading = true
        this.$title('Loading | 线索详情 - 庖丁')
        await Promise.all([
            this.getClueTypeList(),
            this.getDetail()
        ])
        this.getNotPassReasons()
        this.isLoading = false
        this.$nextTick(() => {
            this.initMediaZoomEl()
        })
    }

    /** 获取线索类别列表 */
    private async getClueTypeList() {
        const result = await ClueService.getClueSortList()
        if (result.status === 200) {
            this.clueSortList = result.data
        }
    }

    /** 更新线索信息 */
    private async updateClue() {
        const region = this.clueData.region
        let [province, city, district] = ['', '', '']
        if (region) {
            [province, city, district] = region.split(',')
        }
        const params = {
            id: this.clueId,
            ...this.clueData,
            province,
            city,
            area: district
        }
        Reflect.deleteProperty(params, 'region')
        const result = await ClueService.updateClue(params)
        if (result.status === 200) {
            return true
        }
        return false
    }

    /** 获取详情数据 */
    private async getDetail() {
        const params = { id: this.clueId }
        const result = await ClueService.getClueDetail(params)
        if (result.status === 200) {
            const { 
                title, 
                content, 
                images, 
                clue_type,
                province,
                city,
                area,
                not_pass_reason,
                annexes
            } = result.data
            const addHost = (image: string) => ({ 
                name: +new Date(),
                url: withApiHost(image)     // /v1/img?key=... 需补全 API 域名，否则打到前端域名变成 index.html
            })
            this.$title(`${title} | 线索详情 - 庖丁`)
            this.clueData = {
                id: result.data.id,
                clue_type_id: clue_type.id,
                title,
                content,
                images,
                fileList: images.map(addHost),
                region: [province, city, area],
                status: result.data.status,
                annexes
            }
            this.notPassReason = not_pass_reason
            this.elseInfo = {
                user: result.data.user,
                channel: result.data.channel,
                clue_source: result.data.clue_source
            }
        }
    }

    private onImagePreview({ url }: any) {
        if (!this.mediumZoomEl.length) this.initMediaZoomEl()
        const findFn = (src: any) => src.url === url
        const idx = this.clueData.fileList.findIndex(findFn)
        const imgEl = this.mediumZoomEl[idx]
        mediumZoom(imgEl as HTMLElement).open()
    }

    private initMediaZoomEl() {
        this.mediumZoomEl = document.querySelectorAll('img.el-upload-list__item-thumbnail')
    }

    private onContentChange(content: string) {
        this.clueData.content = content
    }

    private onClearFiles(pointer: any) {
        pointer.uploadRef.uploadFiles.splice(0)
        pointer.rawFileList.splice(0)
        pointer.fileList.splice(0)
        pointer.clue.images.splice(0)
    }

    private onUploadRemove(file: any, fileList: any[], pointer: any) {
        const isSuccess = file.status === 'success'
        let findFn
        if (isSuccess) {
            // clue.images 存原样（可能为相对 /v1/img?key=），file.url 已补全域名，匹配前同样补全
            findFn = (link: any) => (withApiHost(link) === file.url || link === file.url)
            // 图片地址列表
            let imgIdx = pointer.clue.images.findIndex(findFn)
            // 图片文件列表
            imgIdx !== -1 && pointer.clue.images.splice(imgIdx, 1)
            imgIdx = pointer.fileList.findIndex(findFn)
            imgIdx !== -1 && pointer.fileList.splice(imgIdx, 1)
            return
        }
        findFn = (raw: any) => raw.key === file.raw.key
        const idx = pointer.rawFileList.findIndex(findFn)
        idx !== -1 && pointer.rawFileList.splice(idx, 1)
        if (pointer.rawFileList.length < pointer.imgLimit) {
            pointer.uploadEl.style.display = 'inline-block'
        }
    }

    private onReport() {
        this.reportDialog.show()
    }

    /** 新增报道线索 */
    private async createClueReport(params: any) {
        const result = await ClueService.createClueReported(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '线索报道成功',
                showClose: true
            })
            return this.reportDialog.hide()
        }
        this.$message({
            type: 'error',
            message: '发生错误, 线索报道失败',
            showClose: true
        })
        this.reportDialog.stopLoading()
    }

    private onSave() {
        this.publishRef.validate(async (isValid: boolean) => {
            if (isValid) {
                this.clueData = this.publishRef.getClue('clue_update')
                this.isLoading = true
                this.loadingText = '上传图片中'
                let result = await this.publishRef.uploadImg()
                this.clueData.images = [
                    ...this.clueData.images,
                    ...result
                ]
                // 上传线索
                this.isLoading = true
                this.loadingText = '正在上传'
                result = await this.updateClue()
                this.isLoading = false
                if (result) {
                    this.$message({ 
                        type: 'success', 
                        message: '保存成功',
                        showClose: true
                    })
                } else {
                    this.$message({ 
                        type: 'error', 
                        message: '保存失败',
                        showClose: true
                    })
                }
            }
        })
    }

    private async onPass(status: any) {
        await this.updateStatus(status)
    }

    private onReject() {
        this.notpassDialog.show()
    }

    /** 获取审核不通过原因列表 */
    private async getNotPassReasons() {
        const result = await ClueService.getNotPassReasons({})
        if (result.status === 200) {
            this.notPassReasons = result.data
        }
    }

    private onNotPassChange(reasonId: any) {
        this.reasonId = reasonId
        this.updateStatus(this.status.fail)
        this.notpassDialog.hide()
        this.notpassDialog.reset()
    }

    private async updateStatus(status: any) {
        const params = {
            id: this.clueData.id,
            status: status
        }
        this.reasonId && Object.assign(params, { not_pass_reason_id: this.reasonId })
        const result = await ClueService.updateChannelShow(params)
        if (result.status === 200) {
            this.reasonId = 0
            this.$msuccess('操作成功')
            return this.getDetail()
        }
        this.reasonId = 0
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
}
